export const UniversalDashboardReducer = (
  state = { isUniversalDashboardDataTransfered: 'idle' },
  action,
) => {
  switch (action.type) {
    case 'POST_UNIVERSAL_DASHBOARD_DATA':
      return {
        ...state,
        apiResponse: action.payload,
      };

    case 'API_START':
      if (action.payload === 'SET_UNIVERSAL_DASHBOARD_DATA') {
        return {
          ...state,
          isUniversalDashboardDataTransfered: 'loading',
        };
      }
      break;

    case 'API_END':
      if (action.payload === 'SET_UNIVERSAL_DASHBOARD_DATA') {
        return {
          ...state,
          isUniversalDashboardDataTransfered: 'loaded',
        };
      }
      break;

    case 'API_ERROR':
      if (action.payload === 'SET_UNIVERSAL_DASHBOARD_DATA') {
        return {
          ...state,
          isUniversalDashboardDataTransfered: 'error',
        };
      }
      break;
    default:
      return state;
  }
  return state;
};
